import LanguageDropdown from "components/Language/LanguageDropdown"
import React, { Component,useEffect } from "react"
import { Link, withRouter } from "react-router-dom"
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea, Image} from "semantic-ui-react"
import {
	Card,
	Col,
	FormField,
	FormInput,
	Row,
  } from "elemental-react16"
import queryString from "qs"
import shop from "shop/shop"
import FormCMS from "components/Form/FormCMS"
import WordPressContainer from "WordPressContainer"
import languageStore from "stores/languageStore"
import { trackSignUp } from "components/tracking/Tracking";

@withRouter
export default class NewCustomerPage extends Component {

	state = {
			activeStep: 0,
			form1Disabled: false,
			form2Disabled: true,
			form3Disabled: true,
			form4Disabled: true,
			form5Disabled: true,
			form1Check: false,
			form2Check: false,
			form4Check: false,
			newcust: {
				firm: {
					name: "",
					uidnr: "",
					glnnr: "",
					legalForm: "",
					taxNumber: "",
					branche: "",
				},
				person: {
					salutation: "",
					firstname: "",
					lastname: "",
					position: "",
				},
				address: {
					street: "",
					streetnumber: "",
					addition: "",
					postcode: "",
					city: "",
					country: "",
					deliverstreet: "",
					deliverstreetnumber: "",
					deliveraddition: "",
					deliverpostcode: "",
					delivercity: "",
					delivercountry: ""
				},
				contact: {
					email: "",
					phone: "",
					mobile: "",
					web: "",
					comment: ""
				},
				locale: ""
			}
		}

	handleSendCustReg = async (newCustomer) => {
		this.setState({ form4Disabled: true });
		this.setState({ form5Disabled: false });

		const { currentLanguage } = languageStore;
		newCustomer.locale = currentLanguage;

		if (this.state.newcust.contact.email === "" || this.state.newcust.contact.phone === "") {
			shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"));
			return;
		}

		this.state.newcust.address.street = this.state.newcust.address.street + ' ' + this.state.newcust.address.streetnumber;
		if (this.state.newcust.contact.mobile === "") {
			this.state.newcust.contact.mobile = " ";
		}

		try {
			await shop.fetch(`/shop/rest/service/request?id=customer_registration`, {
			method: "POST",
			body: JSON.stringify(newCustomer)
			});

			shop.toast("Kundenregistrierung erfolgreich!");
			console.log("newcust: ", this.state.newcust);

			//GTM Event Trigger
			trackSignUp("email");

			// optional: redirect mit Delay
			// const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
			// await delay(2000);
			// this.props.history.push("/home");
		} catch (err) {
			console.log(err);
			shop.toast(err);
		}
	};
	
	handleFormClearWeiter = ( ) => {

		if(this.state.newcust.firm.name == "" || this.state.newcust.firm.uidnr == "" || this.state.newcust.firm.branche == ""){
			//shop.toast("Alles eingegeben!")
			shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
			return
		} else if(this.state.form2Disabled == false ){ // 
			if(this.state.newcust.contact.phone == "" || this.state.newcust.contact.email == "" || this.state.newcust.person.firstname == "" || this.state.newcust.person.lastname == "" || this.state.newcust.person.position == "" || this.state.newcust.person.salutation == ""){
				shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
				return
			} else if(this.state.form4Disabled == false){
				if( this.state.newcust.address.street == "" || this.state.newcust.address.postcode == "" || this.state.newcust.address.city == "" || this.state.newcust.address.country == ""){
					shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
					return
				}
			}
		}

		if(this.state.form1Disabled == false && this.state.form3Disabled == true){
			this.setState( { form1Disabled: true } )
			this.setState( { form2Disabled: false } )
			this.setState( { form3Disabled: true } )
			this.setState( { activeStep: 1 } )
		}
		else if(this.state.form2Disabled == false && this.state.form3Disabled == true){
			this.setState( { form1Disabled: true } )
			this.setState( { form2Disabled: true } )
			this.setState( { form4Disabled: false } )
			this.setState( { activeStep: 2 } )
		}
		else if(this.state.form3Disabled == false){
			this.setState( { form1Disabled: true } )
			this.setState( { form2Disabled: true } )
			this.setState( { form3Disabled: true } )
			this.setState( { form4Disabled: false } )
			this.setState( { activeStep: 3 } )
		}
		else if(this.state.form4Disabled == false){
			this.setState( { form1Disabled: true } )
			this.setState( { form2Disabled: true } )
			this.setState( { form3Disabled: true } )
			this.setState( { form4Disabled: true } )
			this.setState( { form5Disabled: true } )
		}
		}
	
	handleFormClearDelivery = ( ) => {
		if(this.state.form2Disabled == false ){
			if(this.state.newcust.address.street == "" || this.state.newcust.address.postcode == "" || this.state.newcust.address.city == "" || this.state.newcust.address.country == ""){
				shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
				return
			}
		}
		this.setState( { form1Disabled: true } )
		this.setState( { form2Disabled: true } )
		this.setState( { form3Disabled: false } )
		this.setState( { form4Disabled: true } )
	}

	handleFormClearZurueck  = ( ) => {
		if(this.state.form2Disabled == false){
			this.setState( { form1Disabled: false } )
			this.setState( { form2Disabled: true } )
		}
		else if(this.state.form3Disabled == false){
			this.setState( { form2Disabled: false } )
			this.setState( { form3Disabled: true } )
		}
		else if(this.state.form4Disabled == false){
			if(this.state.newcust.address.deliverstreet == ""){
				this.setState( { form2Disabled: false } )
				this.setState( { form4Disabled: true } )
			}
			else{
				this.setState( { form3Disabled: false } )
				this.setState( { form4Disabled: true } )
			}
		}
		}
	  
	render() {
		const countryOptions = [
			{ key: 'de', value: 'de', flag: 'de', text: 'Deutschland' },
			{ key: 'ch', value: 'ch', flag: 'ch', text: 'Schweiz' },
			{ key: 'be', value: 'be', flag: 'be', text: 'Belgien' },
			{ key: 'bg', value: 'bg', flag: 'bg', text: 'Bulgarien' },
			{ key: 'dk', value: 'dk', flag: 'dk', text: 'Dänermark' },
			{ key: 'ee', value: 'ee', flag: 'ee', text: 'Estland' },
			{ key: 'fi', value: 'fi', flag: 'fi', text: 'Finnland' },
			{ key: 'fr', value: 'fr', flag: 'fr', text: 'Frankreich' },
			{ key: 'gr', value: 'gr', flag: 'gr', text: 'Griechenland' },
			{ key: 'gb uk', value: 'gb uk', flag: 'gb uk', text: 'Grossbritanien' },
			{ key: 'ie', value: 'ie', flag: 'ie', text: 'Irland' },
			{ key: 'it', value: 'it', flag: 'it', text: 'Italien' },
			{ key: 'lv', value: 'lv', flag: 'lv', text: 'Lettland' },
			{ key: 'lt', value: 'lt', flag: 'lt', text: 'Litauen' },
			{ key: 'lu', value: 'lu', flag: 'lu', text: 'Luxemburg' },
			{ key: 'nl', value: 'nl', flag: 'nl', text: 'Niederlande' },
			{ key: 'no', value: 'no', flag: 'no', text: 'Norwegen' },
			{ key: 'at', value: 'at', flag: 'at', text: 'Österreich' },
			{ key: 'pl', value: 'pl', flag: 'pl', text: 'Polen' },
			{ key: 'pt', value: 'pt', flag: 'pt', text: 'Portugal' },
			{ key: 'ro', value: 'ro', flag: 'ro', text: 'Rumänien' },
			{ key: 'se', value: 'se', flag: 'se', text: 'Schweden' },
			{ key: 'sk', value: 'sk', flag: 'sk', text: 'Slowakei' },
			{ key: 'si', value: 'si', flag: 'si', text: 'Slowenien' },
			{ key: 'sp', value: 'sp', flag: 'sp', text: 'Spanien' },
			{ key: 'cz', value: 'cz', flag: 'cz', text: 'Tschechien' },
			{ key: 'tr', value: 'tr', flag: 'tr', text: 'Türkei' },
			{ key: 'hu', value: 'hu', flag: 'hu', text: 'Ungarn' },
			{ key: 'x', value: 'x', flag: 'x', text: 'Andere' },
		  ]
		  const { currentLanguage } = languageStore
		  let genderOptions =[ ]
		  if(currentLanguage == 'en'){
			genderOptions = [
				{ key: 'male', value: 'Herr', text: 'Mister' },
				{ key: 'female', value: 'Frau', text: 'Misses' },
				{ key: 'diverse', value: 'Divers', text: 'Diverse' },
			]
		  }
		  else{
			genderOptions = [
				{ key: 'male', value: 'Herr', text: 'Herr' },
				{ key: 'female', value: 'Frau', text: 'Frau' },
				{ key: 'diverse', value: 'Divers', text: 'Divers' },
			]
		  }

		  const handleChange = (event) => {
			console.log("CHANGE: ", event.target)
			let tempname = event.target.name
			let tempname2 = event.target.className
			let tempvalue = event.target.value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust[tempname][tempname2] = tempvalue;       
				return { newcust }; 
			  })
		  };  
		  const handleDropDownChange = (event, {value}, delivercountry) => {
			let tempvalue = value
			console.log("DROPDOWN CHANGE: ", event.target.value, "VALUE:", value, delivercountry)
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				if(value == "Herr" || value == "Frau"){
					newcust.person.salutation = tempvalue
				} 
				else if(this.state.form4Disabled == false){
					newcust.address.country = tempvalue
				} 
				else if(this.state.form3Disabled == false){
					console.log("DELIVER COUNTRY: ", tempvalue)
					newcust.address.delivercountry = tempvalue
				}     
				return { newcust }; 
			  })
			console.log("NEW CUST: ", this.state.newcust)
		  }; 

		  const handleDropDownChangeDeliver = (event, {value}, delivercountry) => {
			let tempvalue = value
			console.log("DROPDOWN CHANGE: ", event.target.value, "VALUE:", value, delivercountry)
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				if(value == "Herr" || value == "Frau"){
					newcust.person.salutation = tempvalue
				}  
				else if(this.state.form3Disabled == false){
					console.log("DELIVER COUNTRY: ", tempvalue)
					newcust.address.delivercountry = tempvalue
				}     
				return { newcust }; 
			  })
			console.log("NEW CUST: ", this.state.newcust)
		  }; 
		
		 const handleCommentChange = ( event ) => {
			console.log("VALUE:",event.target)
			let comment = event.target.value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust.contact.comment = comment;       
				return { newcust }; 
			  })
		  }
		const { activeStep } = this.state 
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		const { overlay } = query
		const { history } = this.props
		return (
			<div>
				{overlay && <Modal open={true}>
					<Button
						className="absolute right-1 top-1"
						as={Link}
						to={this.props.location.pathname}
						circular
						basic
						icon={"close"}
					/>
					<Modal.Content>
						<WordPressContainer slug={overlay}/>
					</Modal.Content>

					<Modal.Actions>
						<Button
							as={Link}
							to={this.props.location.pathname}
							labelPosition="right"
							content="Zurück"
						/>
					</Modal.Actions>

				</Modal>}
				{/*<div className="pa3">
					<div className="fr"> <LanguageDropdown/></div>
					<Button as={Link} to="/login"><Icon name="chevron left"/>{translate( "back to login" )}</Button>

				</div>*/}
				<div className="mw7 center pt2 pb3 ">

					{/*<div className="tc pb4">
						<Link to="/login">
							<img src={shop.config.logo} title="Zur Startseite"/>
						</Link>
					</div> */}

					{/*<div className="center  pb3">
						<Message>
							<div className="b">{translate("LOGIN_NOTICE_HEADER")}</div>

							<div>{translate("LOGIN_NOTICE1")} <a href="https://shop.orthowalker-kieferorthopaedie.ch/reset_password/">https://shop.orthowalker-kieferorthopaedie.ch/reset_password/</a>
							 {translate("LOGIN_NOTICE2")} <a href="mailto:shop@orthowalker.ch">shop@orthowalker.ch</a>
							 {translate("LOGIN_NOTICE3")}<a href="tel:056 649 24 00">056 649 24 00</a> / <a href="mailto:info@orthowalker.ch">info@orthowalker.ch</a><a>).</a>						
							</div>

							<div className={"tc pt3"}>
								<Button as={Link} to={"/request_password"}>{translate("Passwort anfordern")}</Button>
							</div>
						</Message>
					</div>*/}	

				{/*	<h1>{translate("Neukundenregistrierung")}</h1>
				{translate("Bitte füllen Sie das folgende Formular vollständig aus, damit wir Ihre Registrierung schnellstmöglich prüfen und freischalten können. Die mit * gekennzeichneten Felder sind Pflichtfelder.")}
				<br/><br/>

				<strong>{translate("Bitte beachten Sie:")}</strong><br/><br/>

				{translate("Wir werden Ihre Anmeldung überprüfen und Ihren Zugang schnellstmöglich freischalten. Nach der Freischaltung erhalten Sie die Zugangsdaten per E-Mail. Erst dann können Sie sich in unserem Shop einloggen.")}
				<br/><br/> */}
				<div className="flex flex-row justify-center pa3" >
					<p className="fw7 pa3"><h1 className="fw7">{translate("Registrierung")}</h1></p>
				</div>

				<div className="flex flex-row justify-center pb3 pl4 pr4">
						<table>
							<tbody>
								<tr>
									<td className="tc">
										<div className="pb3 pt3 f5">
											<div><button mini style={{borderRadius: "35px", width: "35px", height: "35px", border: "none", backgroundColor: "#e15635", color: "#ffffff"}}  className="text-centered" >
												{activeStep === 0 ? <p className="fw7">1</p> : <Icon style={{paddingLeft: "3px"}} className="small checkmark"></Icon> }
											</button></div>
										</div>
									</td>
								</tr>
								<tr>
									<div className="tc fw7 f6">{translate("Unternehmen")} </div>
								</tr>
							</tbody>
						</table>
						<div className="pb3 pt3 "><Image src={`${activeStep === 0 ? "/image/Frame161.png" : "/image/Frame160.png"}`} className="pt3 pb3" style={{ filter: "brightness(100%)" }} /></div>
						<table>
							<tbody>
								<tr>
									<td className="tc">
										<div className="pb3 pt3 f5">
											<div><button mini style={{borderRadius: "35px", width: "35px", height: "35px", border: "none", backgroundColor: activeStep == 0 ? "#CCCABD" : "#e15635", color: "#ffffff"}}  className="text-centered" >
												{activeStep <= 1 ? <p className="fw7">2</p> : <Icon style={{paddingLeft: "3px"}} className="small checkmark"></Icon> }
											</button></div>
										</div>
									</td>
								</tr>
								<tr>
									<div className="tc fw7 f6">{translate("Ansprechpartner")} </div>
								</tr>
							</tbody>
						</table>
						<div className="pb3 pt3 "><Image src={`${activeStep <=  1 ? "/image/Frame161.png" : "/image/Frame160.png"}`} className="pt3 pb3" style={{ filter: "brightness(100%)" }} /></div>
						<table>
							<tbody>
								<tr>
									<td className="tc">
										<div className="pb3 pt3 f5">
											<div><button mini style={{borderRadius: "35px", width: "35px", height: "35px", border: "none", backgroundColor: activeStep <= 1 ? "#CCCABD" : "#e15635", color: "#ffffff"}}  className="text-centered" >
												{activeStep <= 2 ? <p className="fw7">3</p> : <Icon style={{paddingLeft: "3px"}} className="small checkmark"></Icon> }
											</button></div>
										</div>
									</td>
								</tr>
								<tr>
									<div className="tc fw7 f6">{translate("Adressdaten")}</div>
								</tr>
							</tbody>
						</table>
				</div>

				{this.state.form1Disabled == false && <Form>
					<div style={{minHeight: "250px"}}>
						<Form.Field required>
							<label>{translate("Firma")}</label>
							<input value={this.state.newcust.firm.name} onChange={handleChange} className="name" name="firm" placeholder={translate("Firmenname")} />
						</Form.Field>
						{/*<Form.Field>
							<label>{translate("GLN-Nummer")}</label>
							<input value={this.state.newcust.firm.uidnr} onChange={handleChange}  className="uidnr" name="firm" placeholder={translate("GLN-Nummer")} />
						</Form.Field>
						<Form.Field>
							<label>{translate("Kundennummer")}</label>
							<input value={this.state.newcust.firm.customernumber} onChange={handleChange}  className="customernumber" name="firm" placeholder={translate("Kundennummer")} />
				</Form.Field>*/}
						<Form.Group widths="equal" style={{ display: "flex", alignItems: "flex-end" }}>
						<Form.Input required label={translate("UID-Nummer (USt-ID)")}><input fluid value={this.state.newcust.firm.uidnr} onChange={handleChange} className="uidnr" name="firm" label="Kundennummer:" placeholder={translate("UID-Nummer")}  /></Form.Input>
						<Form.Input required style={{ display: "flex", alignItems: "flex-start" }} label={translate("Branche")}><input fluid value={this.state.newcust.firm.branche} onChange={handleChange} className="branche" name="firm" label="Branche:" placeholder={translate("Branche")}  /></Form.Input>
					</Form.Group>
					<Form.Field>
							<label>{translate("Webseite")}</label>
							<input value={this.state.newcust.contact.web} onChange={handleChange} className="web" name="contact" nameadd="email" placeholder="trend-soft.de/" />
						</Form.Field>
						
				</div>
				</Form>}
				{this.state.form2Disabled == false && <Form>
					<div style={{minHeight: "300px"}}>
					<Form.Field className="w-50"  required>
						<label>{translate("Anrede")}</label>
						<Dropdown fluid floating style={{backgroundColor: "#F8F7EC"}}
							value={this.state.newcust.person.salutation}
							id="registerPage"
							onChange={handleDropDownChange}
							clearable
							label="Land:"
							className="salutation" 
							name="person"
							required
							selection
							options={genderOptions}
							placeholder={translate("Anrede")}
						/>
					</Form.Field>
					<Form.Group widths="equal">
						<Form.Input required label={translate("Vorname")}><input fluid value={this.state.newcust.person.firstname} onChange={handleChange} className="firstname" test="firstname" name="person" label="Vorname:" placeholder={translate("Vorname")}  /></Form.Input>
						<Form.Input required label={translate("Nachname")}><input fluid value={this.state.newcust.person.lastname} onChange={handleChange} className="lastname" name="person" label="Nachname:" placeholder={translate("Nachname")}  /></Form.Input>
						</Form.Group>
					<Form.Field required >
						<label>{translate("Position im Unternehmen")}</label>
						<input fluid value={this.state.newcust.person.position} onChange={handleChange} className="position" name="person" label="Position im Unternehmen:" placeholder={translate("Position im Unternehmen")}  /></Form.Field>
					
					<Form.Field required>
							<label>{translate("E-Mail")}</label>
							<input value={this.state.newcust.contact.email} onChange={handleChange} className="email" name="contact" nameadd="email" placeholder={translate("E-Mail")} />
						</Form.Field>
						<Form.Group widths="equal">
						<Form.Input required label={translate("Telefon")}><input value={this.state.newcust.contact.phone} onChange={handleChange} required fluid className="phone" name="contact" label="Telefon:" placeholder={translate("Telefon")}  /></Form.Input>
						<Form.Input label={translate("Mobil")}><input value={this.state.newcust.contact.mobile} onChange={handleChange} fluid className="mobile" name="contact" label="Mobil:" placeholder={translate("Mobil")}  /></Form.Input>
						</Form.Group>
					
					</div>
  				</Form>}

				  {this.state.form4Disabled == false && <Form>
					<div style={{minHeight: "300px"}}>
					<p className="fw7 f5 pt3">{translate("Rechnungsadresse")}</p>
						<Form.Group widths="equal">
							<Form.Input width={7} required label={translate("Strasse")}><input value={this.state.newcust.address.street} onChange={handleChange} required fluid className="street" name="address" label="street:" placeholder={translate("Strasse")}  /></Form.Input>
							<Form.Input width={3} required label={translate("Nr.")}><input value={this.state.newcust.address.streetnumber} onChange={handleChange} required fluid className="streetnumber" name="address" label="street:" placeholder={translate("Nr.")}  /></Form.Input>
							<Form.Input width={3} label={translate("Zusatz")}><input value={this.state.newcust.address.addition} onChange={handleChange} className="addition" name="address" nameadd="street" placeholder={translate("Zusatz")} /></Form.Input>
						</Form.Group>
						<Form.Field>
							<label></label>
							
						</Form.Field>
						<Form.Group widths="equal">
							<Form.Input width={3} required label={translate("PLZ")}><input value={this.state.newcust.address.postcode} onChange={handleChange} required fluid className="postcode" name="address" label="PLZ:" placeholder={translate("PLZ")}  /></Form.Input>
							<Form.Input width={7} required label={translate("Ort")}><input value={this.state.newcust.address.city} onChange={handleChange} required fluid className="city" name="address" label="Ort:" placeholder={translate("Ort")}  /></Form.Input>
						</Form.Group>
						<Form.Field required>
						<label>{translate("Land")}</label>
						<Dropdown
							value={this.state.newcust.address.country}
							id="registerPage"
							onChange={handleDropDownChange}
							clearable
							label="Land:"
							className="country" 
							name="address"
							required
							style={{backgroundColor: "#F8F7EC"}}
							selection
							options={countryOptions}
							placeholder={translate("Land")}
						/>
						</Form.Field>
						<Checkbox onClick={() => {this.setState({ form3Disabled: !this.state.form3Disabled})}} label={<label className="fw6 f7"><p className="f7">{translate("Abweichende Lieferadresse eingeben")}</p></label>} />
						
						</div>
  				</Form>}
				 {this.state.form3Disabled == false && <Form>
					<div style={{minHeight: "300px"}}>
					<h3 className="fw7 f5 pt3">{translate("Lieferadresse")}</h3>
											<Form.Group widths="equal">
							<Form.Input width={7}  label={translate("Strasse")}><input value={this.state.newcust.address.deliverstreet} onChange={handleChange} required fluid className="deliverstreet" name="address" label="street:" placeholder={translate("Strasse")}  /></Form.Input>
							<Form.Input width={3}  label={translate("Nr.")}><input value={this.state.newcust.address.deliverstreetnumber} onChange={handleChange} required fluid className="deliverstreetnumber" name="address" label="street:" placeholder={translate("Nr.")}  /></Form.Input>
							<Form.Input width={3}  label={translate("Zusatz")}><input value={this.state.newcust.address.deliveraddition} onChange={handleChange} className="deliveraddition" name="address" nameadd="street" placeholder={translate("Zusatz")} /></Form.Input>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Input width={3} label={translate("PLZ")}><input value={this.state.newcust.address.deliverpostcode} onChange={handleChange}  fluid className="deliverpostcode" name="address" label="PLZ:" placeholder={translate("PLZ.")}  /></Form.Input>
							<Form.Input width={7} label={translate("Ort")}><input value={this.state.newcust.address.delivercity} onChange={handleChange}  fluid className="delivercity" name="address" label="Ort:" placeholder={translate("Ort")}  /></Form.Input>
						</Form.Group>
						
						<Form.Field >
						<label>{translate("Land")}</label>
						<Dropdown
							value={this.state.newcust.address.delivercountry}
							id="registerPage"
							onChange={handleDropDownChangeDeliver}
							clearable
							label="Land:"
							className="delivercountry" 
							name="address"
							required
							style={{backgroundColor: "#F8F7EC"}}
							selection
							options={countryOptions}
							placeholder={translate("Land")}
						/>
						</Form.Field>
						
					</div>
  				</Form>}
				  {this.state.form5Disabled == true && <div className="pa3 tc" >
					<p>{translate("Dieser Onlineshop richtet sich ausschließlich an Fachhändler und Großhändler. Ihr Kundenkonto wird erst nach erfolgreicher Prüfung durch Trendsoft freigeschaltet.")}
					</p>
					</div>}
				{this.state.form5Disabled == false && <div >
					<div className="flex flex-row justify-center pa3" >
						<p className="fw6 f5">{translate("Vielen Dank für Ihre Registrierung!")} </p>
					</div>
					<div className="flex flex-row justify-center pa3" >
						<p className="fw6 f5">{translate("Bitte beachten Sie:")} </p>
					</div>
					<p className="f5 tc">{translate("Wir werden Ihre Registrierung überprüfen und Ihren Zugang schnellstmöglich freischalten. Nach der Freischaltung erhalten Sie die Zugangsdaten per E-Mail. Erst dann können Sie sich in unserem Shop einloggen.")} </p>
					</div>}
				  <div className="pt3" style={{ display: "flex" }} >
				  {/*this.state.form2Disabled == false && <Button style={{
						  borderRadius: "35px", 
						  height: "60px", 
						  width: "200px", 
						  color: "white",
						  transition: "all 0.3s ease",
						  padding: "10px 20px 10px 20px",
						  marginLeft: "auto"
						}}  onClick={this.handleFormClearDelivery} primary>
                    {translate( "Separate Lieferadresse eingeben" )}
                    <i className="icon-angle-right"/>
                  </Button>*/}

				  { this.state.form5Disabled == false &&
						<Button primary style={{
						  borderRadius: "35px", 
						  height: "50px", 
						  width: "100%", 
						  color: "white",
						  transition: "all 0.3s ease",
						  padding: "10px 20px 10px 20px",
						  marginLeft: "auto"
						}} 
						className="ml3 pl3 mr2"
						onClick={() => this.props.history.push("/home")}>
                    {translate( "Zurück zur Startseite" )}
                    <i className="icon-angle-right"/>
                  </Button>}
  				{this.state.form4Disabled == true && this.state.form5Disabled == true &&
						<Button primary style={{
						  borderRadius: "35px", 
						  height: "50px", 
						  width: "100%", 
						  color: "white",
						  transition: "all 0.3s ease",
						  padding: "10px 20px 10px 20px",
						  marginLeft: "auto"
						}} 
						className="ml3 pl3 mr2"
						onClick={this.handleFormClearWeiter}>
                    {translate( "Weiter" )}
                    <i className="icon-angle-right"/>
                  </Button>}
				  {this.state.form4Disabled == false && this.state.form5Disabled == true && <Button style={{
						  borderRadius: "35px", 
						  height: "50px", 
						  width: "100%", 
						  color: "white",
						  transition: "all 0.3s ease",
						  padding: "10px 20px 10px 20px",
						  marginLeft: "auto"
						}}  onClick={() => this.handleSendCustReg(this.state.newcust)} primary>
                    {translate( "Registrierung abschließen" )}
                    <i className="icon-angle-right"/>
                  </Button>}
				  </div>
				  <div className="pt3" style={{ display: "flex" }} >
				  {this.state.form1Disabled == true && this.state.form5Disabled == true && <Button 
					style={{
					borderRadius: "35px", 
					height: "50px", 
					width: "100%", 
					backgroundColor: "#646363ff", 
					border: "2px solid #e15635", 
					color: "black",
					transition: "all 0.3s ease"
					}} 
					className="fw5 ml3 pl3"
					onMouseEnter={(e) => {
					e.target.style.backgroundColor = "#353535";
					e.target.style.color = "white";
					e.target.style.border = "2px solid #e15635";
					}}
					onMouseLeave={(e) => {
					e.target.style.backgroundColor = "#646363ff";
					e.target.style.color = "black";
					e.target.style.border = "2px solid #e15635";
					}}  onClick={this.handleFormClearZurueck} primary>
                    {translate( "Zurück" )}
                    <i className="icon-angle-right"/>
                  </Button>}
				  </div>
					{/*<FormCMS slug={"customer_registration"} onSuccess={() => {
						history.push( "/login" )
						window.swal( translate("Neukundenanmeldung erhalten"), translate("Vielen Dank für Ihre Anmeldung. Sie erhalten Ihre Anmeldedaten per E-Mail"), "success" )
					}}/>*/}
				</div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/theme/trendimport.test/pages/NewCustomerPage.js